export default class IsDirtySet<Id extends string> {
  private _set: Set<Id> = new Set();

  constructor(
    private saveToCache: (ids: string[]) => Promise<void>,
    private clearCache: () => Promise<void>,
  ) {}

  async flag(ids: Id[]) {
    ids.forEach((id) => this._set.add(id));
    await this.saveToCache([...this._set]);
  }

  async unflag(ids: Id[]) {
    ids.forEach((id) => this._set.delete(id));
    await this.saveToCache([...this._set]);
  }

  has(id: Id) {
    return this._set.has(id);
  }

  getAll(): Id[] {
    return Array.from(this._set);
  }

  import(ids: Id[]) {
    ids.forEach((id) => this._set.add(id));
  }

  async clear() {
    this._set = new Set();
    await this.clearCache();
  }
}
